<mat-form-field appearance="outline" class="wide filter" [class.active]="selectControl.value !== undefined">
    <mat-label>{{ title }}</mat-label>
    <mat-select [formControl]="selectControl" [multiple]="isMultiAllowed">
        <mat-option *ngFor="let opt of options" [value]="opt">
            {{ opt.display }}
        </mat-option>
    </mat-select>
</mat-form-field>
